/**
 * Sanitise a `?next=` redirect target.
 *
 * Without this, `/login?next=//evil.com` would send a freshly signed-in user
 * straight off the site: a protocol-relative URL is resolved by the browser as
 * an external origin. Only same-origin absolute paths are accepted.
 */
export function safeRedirectPath(raw: string | null | undefined, fallback = '/'): string {
  if (!raw) return fallback;

  // Must be an absolute path on this origin…
  if (!raw.startsWith('/')) return fallback;
  // …and not a protocol-relative or scheme-relative escape.
  if (raw.startsWith('//') || raw.startsWith('/\\')) return fallback;

  return raw;
}
